import Header from './header';
import Sidebar from './sidebar';
import Base from './base';

const AppShell = {
	Header,
	Sidebar,
	Base,
};

export default AppShell;
